import React from "react";
import { useForm, ValidationError } from "@formspree/react";
import Collapse from "./Collapse";

function Anpaddeln_Form() {
  const [state, handleSubmit] = useForm("mvggvrlv");
  if (state.succeeded) {
    // if (true) {
    return (
      <div className="form__container">
        <p>
          <b>Vielen Dank für die Anmeldung!</b>
          <br />
          <br />
          Wir melden uns ab dem 28.02.2026 mit weiteren Informationen. Wir
          freuen uns auf euch. Viele Grüße vom Caipi Orga Team
        </p>
      </div>
    );
  }
  return (
    <div className="form__container">
      <form onSubmit={handleSubmit}>
        <div className="fullWidth">
          <h3>Ahoi ihr Wasserratten und Drachenbändiger!</h3>
          <p>
            Der Frühling steht vor der Tür, die Boote liegen am Start und die
            Paddel wollen endlich wieder Wasser sehen! Gemeinsam wollen wir die
            neue Saison eröffnen – dieses Jahr unter dem Motto:&nbsp;
            <b>„Brücken schlagen“</b>
          </p>
          <br />
          <p>
            Brücken schlagen heißt: Verbindungen schaffen und gemeinsam in eine
            Richtung paddeln. Im Drachenboot bedeutet das - Kraft und Rhythmus
            finden zusammen, Erfahrung begegnet Neugier, und aus Einzelnen wird
            ein Team. Also entstaubt Eure Crew, schnappt Euch Eure Paddel und
            seid dabei beim
          </p>
          <br />
          <h3>Anpaddeln am Samstag, den 11. April 2026!</h3>
          <br />
          <p>
            Wir planen spannende Stationen, kleine Herausforderungen und
            natürlich ein köstliches Buffet. Euer Teamgeist ist gefragt – denn
            wer Brücken schlagen will, muss manchmal auch über das eigene Boot
            hinaus paddeln.
          </p>
          <br />
          <p>
            <b>Wann:</b> Samstag, 11.04.2026
            <br />
            <b>Wo:</b> WSAP Steg, Isekai 12, Hamburg
            <br />
            <b>Startgeld:</b> 10 € pro Kopf <br />
            <b>Boote:</b> Mindestens 3 (bei weniger behalten wir uns eine Absage
            vor), maximal 10
          </p>
          <br />
          <p>
            <b>Bootsbesetzung:</b> Wir empfehlen euch, mit&nbsp;
            <b>14 – 18 Paddlern</b> an den Start zu gehen. Euer Boot braucht
            Platz für Verpflegung, gute Laune – und vielleicht das eine oder
            andere Bestechungsmaterial. Euer Boot benötigt auf jeden Fall eine
            Trommel, diese muss aber nicht immer besetzt sein.
          </p>
          <br />
          <p>
            <b>Anmeldeformular:</b> Bitte meldet Euch als gesamtes Team an. Ihr
            möchtet mit Eurem Team gerne dabei sein, seid aber nicht komplett?
            In der Anmeldung werden wir abfragen, wie viel Paddler ihr seid, ob
            ihr bereits ein Boot, eine Person an der Trommel oder am Steuer
            habt. Basierend auf euren Angaben werden wir bei Bedarf
            Renngemeinschaften zusammenstellen.
          </p>
          <br />
          <p>
            <b>Anmeldung bis:</b> 28. Februar 2026
          </p>
          <br />
          <p>
            Bei Fragen schreibt uns eine Mail an:{" "}
            <a href="mailto:anpaddeln@caipis-drachenboot.de">
              anpaddeln@caipis-drachenboot.de
            </a>
            <br />
            Wir freuen uns auf Eure zahlreichen Anmeldungen!
            <br />
            <br />
            Caipi Grüße vom <br />
            Anpaddeln Orga Team
          </p>
          <br />
          <br />
        </div>
        <div className="fullWidth">
          <h3>Allgemeine Infos</h3>
        </div>
        <div>
          <label htmlFor="Vorname_Nachname">Vor- und Nachname *</label>
          <br />
          <input
            id="Vorname_Nachname"
            type="text"
            name="Vorname_Nachname"
            required
          />
        </div>
        <div>
          <label htmlFor="PLZ_Ort">PLZ und Ort *</label>
          <br />
          <input id="PLZ_Ort" type="text" name="PLZ_Ort" required />
        </div>
        <div>
          <label htmlFor="Telefon">Telefon *</label>
          <br />
          <input id="Telefon" type="telephone" name="Telefon" required />
        </div>
        <div>
          <label htmlFor="Email">E-Mail-Addresse *</label>
          <br />
          <input id="Email" type="email" name="Email" required />
          <ValidationError prefix="Email" field="email" errors={state.errors} />
        </div>
        <br />
        <div className="fullWidth">
          <h3>Eure Mannschaft</h3>

          <p>
            Am Veranstaltungstag ist eine unterschriebene Liste der
            teilnehmenden Paddler beim Organisationsteam abzugeben. Ihr erhaltet
            den Vordruck zusammen mit der Anmeldebestätigung per E-Mail.
          </p>
        </div>
        <div>
          <label htmlFor="Mannschaftsname">Mannschaftsname *</label>
          <br />
          <input
            id="Mannschaftsname"
            type="text"
            name="Mannschaftsname"
            required
          />
        </div>
        <div>
          <label htmlFor="Vereinname">Verein *</label>
          <br />
          <input id="Vereinname" type="text" name="Vereinname" required />
        </div>
        <div>
          <label htmlFor="Teilnehmer">Anzahl der Teilnehmer *</label>
          <br />
          <input
            type="number"
            id="Teilnehmer"
            name="Teilnehmer"
            min="1"
            max="22"
            required
          />
        </div>
        <div>
          <label htmlFor="Andere_Paddler">Platz für andere Paddler *</label>
          <br />
          <input
            type="number"
            id="Andere_Paddler"
            name="Andere_Paddler"
            min="0"
            max="20"
            required
          />
        </div>
        <div>
          <p>Wir haben eine Person, die steuert *</p>
          <label>
            <input type="radio" name="Steuerer" value="Ja" required /> Ja
          </label>
          <label>
            <input type="radio" name="Steuerer" value="Nein" required /> Nein
          </label>
        </div>
        <div>
          <p>Wir haben eine Person, die trommelt *</p>
          <label>
            <input type="radio" name="Trommler" value="Ja" required /> Ja
          </label>
          <label>
            <input type="radio" name="Trommler" value="Nein" required /> Nein
          </label>
        </div>
        <div>
          <p>Wir haben ein Boot *</p>
          <label>
            <input type="radio" name="Boot" value="Ja" required /> Ja
          </label>
          <label>
            <input type="radio" name="Boot" value="Nein" required /> Nein
          </label>
        </div>
        <br />
        <br />
        <br />
        <div className="fullWidth">
          <p className="small">
            * Pflichtfelder, diese Felder müssen ausgefüllt werden.
          </p>
        </div>
        <br />
        <br />
        <div className="fullWidth">
          <h3>Informationen</h3>
        </div>
        <div className="fullWidth">
          <p>
            Das Startgeld EUR 10,00 pro Person ist in einer Summe zu überweisen.
            Nach Ablauf der Anmeldefrist werden wir uns bei euch melden und euch
            sämtliche weitere Informationen sowie die Bankverbindung zukommen
            lassen.
          </p>
        </div>
        <div className="fullWidth">
          <Collapse
            headline="Teilnahmebedingungen und Sicherheitsbelehrung"
            content={
              <>
                <ol>
                  <li>Teilnahmeberechtigt sind Teams nach Erhalt einer Anmeldebestätigung sowie nach Zahlung des Startgeldes in Höhe von 10,00 € pro Person innerhalb der in der Anmeldebestätigung genannten Frist.</li>
                  <li>Jedes Team benennt einen Teamcaptain (TC). Dieser ist während der Veranstaltung Ansprechpartner für den Veranstalter und nimmt verpflichtend am TC-Meeting teil. Außerdem ist er verantwortlich für sein Team, insbesondere die Einhaltung der Rennregeln und der Sicherheitsbestimmungen.</li>
                  <li>Der TC verpflichtet sich, diese „Teilnahmebedingungen und Sicherheitsbelehrung" allen Teammitgliedern vor der Veranstaltung bekannt zu machen. Mit seiner Unterschrift bestätigt der TC, dass alle Teammitglieder die Teilnahmebedingungen und Sicherheitsbelehrung zur Kenntnis genommen haben.</li>
                  <li>Alle Teilnehmenden nehmen an der Veranstaltung auf eigene Gefahr teil.</li>
                  <li>Teilnehmen darf nur, wer mindestens 50 Meter in der Kleidung, die er während des Events im Boot trägt, sicher schwimmen kann.</li>
                  <li>Den Anweisungen des Veranstalters, dessen Erfüllungsgehilfen sowie der Steuerleute ist zur eigenen Sicherheit uneingeschränkt Folge zu leisten.</li>
                  <li>Verhalten einzelner Teammitglieder, das andere Teilnehmende gefährdet, unsportliches Verhalten sowie Alkoholisierung können zum Ausschluss oder zur Disqualifikation des betreffenden Teams führen. Gleiches gilt bei Verstößen jeglicher Art gegen diese Teilnahmebedingungen.</li>
                  <li>Am WSAP-Bootshaus stehen Umkleideräume zur Verfügung. Der Veranstalter übernimmt jedoch keine Haftung für abhandengekommene Bekleidungs- und Ausrüstungsgegenstände sowie Wertsachen der Teilnehmenden.</li>
                  <li>Es wird ein Buffet mit Salaten, Brot, Obst etc. geben. Das Essen wird gegen Spende ausgegeben, die einem guten Zweck zukommen wird. Eigene Verpflegung darf mitgebracht werden.</li>
                  <li>Es stehen keine kostenlosen Parkplätze zur Verfügung. Der Isekai ist eine Wohnstraße mit beiderseitigen kostenpflichtigen Parkmöglichkeiten.</li>
                  <li>Jedes Team ist verpflichtet, seinen Müll einzusammeln, mitzunehmen und einer ordnungsgemäßen Entsorgung zuzuführen.</li>
                  <li>Bei minderjährigen Teilnehmenden ist ein schriftliches Einverständnis der Erziehungsberechtigten erforderlich. Der TC bestätigt mit seiner Unterschrift auf der Anmeldung, dass nur Teilnehmende mit entsprechender Zustimmungserklärung starten.</li>
                  <li>Für minderjährige Teilnehmende besteht Schwimmwestenpflicht.</li>
                  <li>Boote und Paddel werden nicht gestellt und sind von den Teams selbst zu organisieren. Auf Anfrage kann der Veranstalter bei der Organisation eines Bootes gegebenenfalls unterstützend tätig werden.</li>
                  <li>Die Veranstaltung findet bei nahezu jeder Witterung statt. Bei Unwetter kann der Veranstalter die Veranstaltung verkürzen oder absagen. Eine Rückerstattung des gezahlten Startgeldes erfolgt in diesem Fall nicht. Gleiches gilt, wenn die Veranstaltung aus anderen Gründen, die nicht im Verantwortungsbereich des Veranstalters liegen (z. B. behördliche Anordnung), nicht stattfinden kann.</li>
                  <li>Teams, die nicht oder nicht pünktlich zum Start erscheinen, können von der Veranstaltung ausgeschlossen werden. Eine Rückerstattung des Startgeldes erfolgt in diesem Fall nicht.</li>
                  <li>Der Veranstalter, die Sponsoren sowie freiwillige Helfer haften nicht für Sach- oder Vermögensschäden, mit Ausnahme von solchen Schäden, die auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung des Veranstalters oder deren Erfüllungsgehilfen beruhen.</li>
                  <li>Der Veranstalter entscheidet endgültig und unanfechtbar in allen Fragen des Wettbewerbs.</li>
                  <li>Die Teilnehmenden erklären sich damit einverstanden, dass während der Veranstaltung Foto- und Videoaufnahmen angefertigt werden und diese später im Internet oder in anderen Medien veröffentlicht werden dürfen. Sofern kein Einverständnis besteht, ist der Veranstalter vor Veranstaltungsbeginn in Textform zu informieren.</li>
                </ol>
              </>
            }
          />
        </div>
        <div className="fullWidth">
          {/* <button type="submit" disabled={state.submitting}>
            <span>Abschicken</span>
            <div class="loader"></div>
          </button> */}

          <button
            type="submit"
            disabled={state.submitting}
            className={`submit-button ${state.submitting ? "loading" : ""}`}
          >
            <span>{state.submitting ? "Wird gesendet..." : "Abschicken"}</span>
            {state.submitting && <div className="loader"></div>}
          </button>

          <br />
          <p className="small">
            Mit dem Absenden dieses Formulars melde ich mich und meine
            Mannschaft verbindlich zum Anpaddeln 2026 an. Ich habe die
            Teilnahmebedingungen gelesen und erkenne diese uneingeschränkt an.
          </p>
        </div>
        <br />
        <br />
      </form>
    </div>
  );
}

export default Anpaddeln_Form;
